var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.GradientImageCanvasSource = new Class({
    Extends: OCS.Viewer.Classes.ImageCanvasSource,
    class_name: "GradientImageCanvasSource",
    options: {
        metadata: {
            source_type: 'GradientImageCanvas'
        },
        precision: 0
    },

    draw_canvas: function (pixel_delta, canvas_info) {
        var cvs = this.get_canvas();
        var data = this.get_json_data();
        if (!data) {
            return;
        }
        var data_container = data.data;
        var data_properties = data_container['grid-properties'];
        var variable = this.get_variables()[0];
        var data_grid = data_container.variables[variable.parm].data;

//      Uncomment the following line for a uniform test grid.
//        data_grid = this.make_test_grid(data_grid.length, data_grid[0].length);

        var delta_lon = data_properties.delta[0],
                delta_lat = data_properties.delta[1],
                origin_lon = data_properties.origin[0],
                origin_lat = data_properties.origin[1],
                end_lat = origin_lat + (delta_lat * (data_grid.length - 1)),
                end_lon = origin_lon + (delta_lon * (data_grid[0].length - 1));

        var transformFunction = ol.proj.getTransform(OCS.Viewer.Config.default_display_projection, OCS.Viewer.Config.default_projection);
        var transformReverseFunction = ol.proj.getTransform(OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_display_projection);

        var canvas_latlon_extent = ol.extent.applyTransform(this.canvas_draw_args.extent, transformReverseFunction);
        var grid_latlon_extent = ol.extent.boundingExtent([[origin_lon, end_lat], [end_lon, origin_lat]]);
        var intersection_extent = ol.extent.getIntersection(canvas_latlon_extent, grid_latlon_extent);

        if (ol.extent.isEmpty(intersection_extent)) {
            return cvs;
        }

        var gridPlotInfo = this.visibleGridInfo(intersection_extent, data_container, variable.parm);
        if (!gridPlotInfo.isValid) {
            return cvs;
        }
        var grid_subset_extent = ol.extent.applyTransform(gridPlotInfo.extent, transformFunction);

        var numPoints = [];
        numPoints.x = (gridPlotInfo.index.right - gridPlotInfo.index.left) + 1;
        numPoints.y = (gridPlotInfo.index.top - gridPlotInfo.index.bottom) + 1;
        end_lon = gridPlotInfo.extent[2];
        end_lat = gridPlotInfo.extent[3];


        var grid_topLeft = this.get_pixel_from_coordinate([gridPlotInfo.extent[0], end_lat], pixel_delta);
        var grid_bottomRight = this.get_pixel_from_coordinate([end_lon, gridPlotInfo.extent[1]], pixel_delta);
        var gridPixelExtent = [
            Math.floor(grid_topLeft.x),
            Math.floor(grid_topLeft.y),
            Math.ceil(grid_bottomRight.x),
            Math.ceil(grid_bottomRight.y)
        ];

        var grid_pixels = {
            extent: gridPixelExtent,
            width: ol.extent.getWidth(gridPixelExtent),
            height: ol.extent.getHeight(gridPixelExtent)
        };
        var grid_canvas_y = gridPixelExtent[1];

        var lat_per_pixel = delta_lat * ((numPoints.y - 1) / grid_pixels.height);
        var ypixels_per_row = /*Math.floor*/(grid_pixels.height / (numPoints.y - 1));

        var state = {
            ypixels_per_row: ypixels_per_row,
            lat_per_pixel: lat_per_pixel,
            grid_pixels: grid_pixels,
            datarow: gridPlotInfo.index.top,
            data: data_container,
            dataGrid: data_grid,
            variable: variable,
            current_y: grid_canvas_y,
            current_lat: end_lat,
            gridInfo: gridPlotInfo,
            grid_topLeft: ol.extent.getTopLeft(grid_subset_extent),
            grid_bottomRight: ol.extent.getBottomRight(grid_subset_extent)
        };

        // if the canvas height is equal or smaller than the grid cell's pixel height, draw only in the canvas window
        if (this.canvas_draw_args.size[1] <= ypixels_per_row) {
            // compute values at 4 corners of canvas area
            state.dataGrid = [[
                    this.valueFromLonLat(ol.extent.getBottomLeft(canvas_latlon_extent)).value, // bottom left
                    this.valueFromLonLat(ol.extent.getBottomRight(canvas_latlon_extent)).value // bottom right
                ], [
                    this.valueFromLonLat(ol.extent.getTopLeft(canvas_latlon_extent)).value, // top left
                    this.valueFromLonLat(ol.extent.getTopRight(canvas_latlon_extent)).value // top right
                ]];
            grid_topLeft = this.get_pixel_from_coordinate(ol.extent.getTopLeft(canvas_latlon_extent), pixel_delta);
            grid_bottomRight = this.get_pixel_from_coordinate(ol.extent.getBottomRight(canvas_latlon_extent), pixel_delta);
            grid_pixels.extent = [
                Math.floor(grid_topLeft.x),
                Math.floor(grid_topLeft.y),
                Math.ceil(grid_bottomRight.x),
                Math.ceil(grid_bottomRight.y)
            ];
            grid_pixels.width = Math.ceil(ol.extent.getWidth(grid_pixels.extent));
            grid_pixels.height = Math.ceil(ol.extent.getHeight(grid_pixels.extent));
            state.grid_pixels = grid_pixels;

            state.datarow = 1;
            state.current_y = grid_pixels.extent[1];
            state.current_lat = canvas_latlon_extent[3];
            state.ypixels_per_row = grid_pixels.height;

            delta_lat = canvas_latlon_extent[3] - canvas_latlon_extent[1];
            state.lat_per_pixel = delta_lat / grid_pixels.height;
            state.gridInfo.index.right = 1;
            state.gridInfo.index.left = 0;
            state.gridInfo.index.top = 1;
            state.gridInfo.index.bottom = 0;
        }
        this.gradient_timeout(state);
    },

    /**
     * Gradient timeout system allowing for browser responsiveness.
     * @argument {Object} state 
     * @method gradient_timeout
     */
    gradient_timeout: function (state) {
        if (!this.options) {
            // Just in case a timeout fires after we have deleted a layer.
            return;
        }

        var grid_columns = (state.gridInfo.index.right - state.gridInfo.index.left) + 1;
        var numInterpolatedColumns = grid_columns - 1; //(grid_columns * 2) - 1;
        var interpolatedYs, yStart, yStop, yIndex, y;
        var grid_pixel_width = state.grid_pixels.width;
        var context = this.get_context();
        while (state.datarow > state.gridInfo.index.bottom)
        {
            //           setTimeout(function() {
            interpolatedYs = this.calc_column_colors(state);
            yStart = state.current_y;
            yStop = state.current_y + state.ypixels_per_row;
            yIndex = 0;
            for (y = yStart; y < yStop; y++) { // iterating over y (row) pixels
                context.save();
                //parse the interpolated ys we found above, and create the long grads
                this.doGradLinear(state.current_y, state.grid_pixels, this.create_x_gradstops(interpolatedYs, grid_pixel_width, numInterpolatedColumns, yIndex));
                context.restore();
                state.current_lat -= state.lat_per_pixel;
                state.current_y += 1;
                yIndex++;
            }
            //state.current_lat = orig_lat - state.gridInfo.delta.lat; //(state.lat_per_pixel * state.ypixels_per_row);
            interpolatedYs = [];
            state.datarow--;

//           }.bind(this), 0);
        }
        this.drawn = true;
        this.fireEvent(OCS.Viewer.Config.events.LAYER_DRAW_FINISH, this);
    },
    /**
     * create_x_gradstops
     * @param {Array} interpolatedYs
     * @param {Number} grid_pixel_width
     * @param {Number} numInterpolatedColumns
     * @param {Number} yIndex
     * @returns {Array}
     */
    create_x_gradstops: function (interpolatedYs, grid_pixel_width, numInterpolatedColumns, yIndex) {
        var frac, new_frac, leftSideIndex, rightSideIndex, leftSideFrac, rightSideFrac, counter, i, x, valid_right;
        counter = 0;
        var gradStops = [];
        leftSideIndex = -1;
        rightSideIndex = -1;
        leftSideFrac = 0;
        rightSideFrac = 0;
        var util = OCS.Viewer.Functions.get_utilities();
        for (x = 0; x < interpolatedYs.length; x++) { // iterating over x (column) bins
            valid_right = Boolean(interpolatedYs[x] !== -1);
            if (counter > 0) {
                if (valid_right === true) {  // right side of the cell has data
                    leftSideIndex = gradStops[counter - 1].index;
                    if (leftSideIndex !== -1) {  // left side of the cell has data
                        rightSideIndex = interpolatedYs[x][yIndex];
                        leftSideFrac = gradStops[counter - 1].frac;
                        rightSideFrac = util.get_frac(x, 0, numInterpolatedColumns, 0, 1);

                        if (leftSideIndex < rightSideIndex) {
                            //left color is lower index
                            for (i = leftSideIndex; i < rightSideIndex; i++) {
                                if (i > leftSideIndex && i < rightSideIndex) {
                                    //this opt_index index is between our left and right side indexes
                                    new_frac = util.get_frac(i, leftSideIndex, rightSideIndex, leftSideFrac, rightSideFrac) + leftSideFrac;
                                    //console.log("L:" + new_frac);
                                    gradStops[counter] = this.create_gradstop(new_frac, i, grid_pixel_width);
                                    counter++;
                                }
                            }
                        } else if (leftSideIndex > rightSideIndex) {
                            //right color is lower index
                            for (i = leftSideIndex; i >= rightSideIndex; i--) {
                                if (i < leftSideIndex && i > rightSideIndex) {
                                    new_frac = util.get_frac(i, rightSideIndex, leftSideIndex, rightSideFrac, leftSideFrac) + rightSideFrac;
                                    //          console.log("R:" + new_frac);
                                    gradStops[counter] = this.create_gradstop(new_frac, i, grid_pixel_width);
                                    counter++;
                                }
                            }
                        } else {
                            //left and right color are equal
                            //not sure if we should be doing something here.
                        }
                        gradStops[counter] = this.create_gradstop(rightSideFrac, parseInt(interpolatedYs[x][yIndex]), grid_pixel_width);
                        counter++;
                    } else { // left side of bin has no data
                        // Avoid the fade from transparent look
                        frac = util.get_frac(x, 0, numInterpolatedColumns, 0, 1);
                        frac -= 0.000001;
                        gradStops[counter] = this.create_gradstop(frac, -1, grid_pixel_width);
                        counter++;

                        // Start the new color
                        gradStops[counter] = this.create_gradstop(frac, interpolatedYs[x][yIndex], grid_pixel_width);
                        counter++;
                    }

                } else { // right side of bin has no data
                    if (gradStops[counter - 1].index !== -1) { // avoid the "fade to transparent" look
                        gradStops[counter] = this.create_gradstop(gradStops[counter - 1].frac + 0.000001, -1, grid_pixel_width);
                        counter++;
                    }
                    gradStops[counter] = this.create_gradstop(util.get_frac(x, 0, 0, numInterpolatedColumns, 0, 1), -1, grid_pixel_width);
                    counter++;
                }
            } else { // far left side
                if (interpolatedYs[x] === -1)
                    gradStops[counter] = this.create_gradstop(0, -1, grid_pixel_width);
                else
                    gradStops[counter] = this.create_gradstop(0, parseInt(interpolatedYs[x][yIndex]), grid_pixel_width);
                counter++;
            }
            
            if (isNaN(gradStops[counter - 1].index))
                console.warn("gradStop index is NaN");
            else if (gradStops[counter - 1].index === undefined)
                console.warn("gradStop index is undefined");

        }
        return gradStops;
    },
    create_gradstop: function (fraction, index, grid_pixel_width) {
        return {frac: fraction, index: index, offset: Math.ceil(grid_pixel_width * fraction)};
    },
    calc_column_colors: function (inState) {
        var outYArray = [];
        var currArray = [];
        var columnStart = inState.gridInfo.index.left;
        var columnEnd = inState.gridInfo.index.right;
        var inData = inState.dataGrid;
        var row = inState.datarow;
        var ulindex = 0;
        var llindex = 0;
        var pallete = this.palette;


        for (var datacol = columnStart; datacol <= columnEnd; datacol++) { // iterating over x (column) bins
//            midArray = -1;
            if (inData[row] === null || inData[row - 1] === null || inData[row] === undefined || inData[row - 1] === undefined) {
                currArray = -1;
            } else {
                if (inData[inState.datarow][datacol] !== null && inData[inState.datarow - 1][datacol] !== null && inData[inState.datarow][datacol] !== undefined && inData[inState.datarow - 1][datacol] !== undefined) {
                    ulindex = pallete.get_index(inData[inState.datarow][datacol]);
                    llindex = pallete.get_index(inData[inState.datarow - 1][datacol]);
                    currArray = this.fill_index_bins(ulindex, llindex, pallete.max_index, pallete.min_index, inState.current_y, inState.ypixels_per_row);
                } else {
                    currArray = -1;
                }
            }
            outYArray.push(currArray);
        }
        currArray = [];
        return outYArray;
    },
    /**
     * Creates index bins for interpolated y values.
     *
     * @method fill_index_bins
     */
    fill_index_bins: function (index1, index2, index_max, index_min, startY, height) {
        index1 = parseFloat(index1);
        index2 = parseFloat(index2);
        height = Math.ceil(height);

        var step = 1 / height;

        var delta_index = parseFloat(index2 - index1);

        var indexes = Array();
        var currY = startY;
        var endY = startY + height;

        var fraction = 0;
        var index;
        while (currY < endY)
        {
            index = index1 + (delta_index * fraction);

            index = Math.min(index, index_max);
            index = Math.max(index, index_min);
            indexes.push(parseInt(index));
            fraction += step;
            currY += 1;
        }
        return indexes;
    }, //fill_index_bins

    doGradLinear: function (inY, inGridPixels, inGradStops) {
        var left = inGridPixels.extent[0];
        var right = left + inGridPixels.width;
        var context = this.get_context();
        var linGrad = context.createLinearGradient(left, 0, right, 0);
        var util = OCS.Viewer.Functions.get_utilities();
        for (var i = 0, il = inGradStops.length; i < il; i++) {
            if (inGradStops[i].index < 0) {
                linGrad.addColorStop(inGradStops[i].frac, 'transparent');
            } else {
                var stop_color = util.hexa2rgba(this.palette.get_color(inGradStops[i].index));
                if (stop_color === undefined) {
                    linGrad.addColorStop(inGradStops[i].frac, 'transparent');
                } else {
                    var color = 'rgba(' + stop_color.red + ',' + stop_color.green + ',' + stop_color.blue + ',' + stop_color.alpha + ')';
                    linGrad.addColorStop(inGradStops[i].frac, color);
                }
            }
        }
        context.fillStyle = linGrad;
        context.fillRect(left, inY, inGridPixels.width, 1.0); //x,y,width,height
    },
    visibleGridInfo: function (inPlotExtent, inData, inDataVar) {
        var outInfo = {
            delta: {
                lat: inData['grid-properties'].delta[1],
                lon: inData['grid-properties'].delta[0]
            },
            extent: [],
            index: {
                left: 0,
                bottom: 0,
                right: inData.variables[inDataVar].data[0].length - 1,
                top: inData.variables[inDataVar].data.length - 1
            },
            isValid: true
        };


        var origin = {
            lon: inData['grid-properties'].origin[0],
            lat: inData['grid-properties'].origin[1]
        };

        var end = [];
        end.lat = origin.lat + (outInfo.delta.lat * outInfo.index.top);
        end.lon = origin.lon + (outInfo.delta.lon * outInfo.index.right);

        outInfo.extent = ol.extent.boundingExtent([[origin.lon, origin.lat], [end.lon, end.lat]]);

        if (ol.extent.containsExtent(inPlotExtent, outInfo.extent)) {
            return outInfo;
        }

        var optimized_origin = ol.extent.getBottomLeft(inPlotExtent);
        var optimized_end = ol.extent.getTopRight(inPlotExtent);

        outInfo.index.left = Math.floor((optimized_origin[0] - origin.lon) / outInfo.delta.lon);
        outInfo.index.right = Math.ceil((optimized_end[0] - origin.lon) / outInfo.delta.lon);
        outInfo.index.bottom = Math.floor((optimized_origin[1] - origin.lat) / outInfo.delta.lat);
        outInfo.index.top = Math.ceil((optimized_end[1] - origin.lat) / outInfo.delta.lat);

        end.lon = origin.lon + (outInfo.delta.lon * outInfo.index.right);
        end.lat = origin.lat + (outInfo.delta.lat * outInfo.index.top);
        origin.lon += outInfo.delta.lon * outInfo.index.left;
        origin.lat += outInfo.delta.lat * outInfo.index.bottom;

        outInfo.extent = ol.extent.boundingExtent([[origin.lon, origin.lat], [end.lon, end.lat]]);

        origin = [];
        end = [];

        return outInfo;
    },

    valueFromLonLat: function (inLonLat) {
        var theData = this.get_data();
        var variables = this.get_variables();
        var gridParam = variables[0].parm;
        var unit = variables[0].unit;
        var gridData = theData.variables[gridParam].data;
        var gridProperties = theData['grid-properties'];
        var gridOrigin = gridProperties.origin;
        var gridDelta = gridProperties.delta;

        var i = Math.floor((inLonLat[0] - gridOrigin[0]) / gridDelta[0]);
        var j = Math.floor((inLonLat[1] - gridOrigin[1]) / gridDelta[1]);

        if ((i < 0) || (j < 0))
            return null;
        if ((j >= gridData.length - 1) || (i >= gridData[0].length - 1))
            return null;

        var dx = inLonLat[0] - (gridOrigin[0] + (i * gridDelta[0]));
        var dy = inLonLat[1] - (gridOrigin[1] + (j * gridDelta[1]));

        var cellValues = [
            gridData[j][i], // bottom left
            gridData[j][i + 1], // bottom right
            gridData[j + 1][i], // top left
            gridData[j + 1][i + 1]  // top right
        ];
        var util = OCS.Viewer.Functions.get_utilities();
        var hasNull = util.array_null_check(cellValues);
        if (hasNull)
            return null;

        var outValue = (
                cellValues[0] * (gridDelta[0] - dx) * (gridDelta[1] - dy)
                + cellValues[1] * dx * (gridDelta[1] - dy)
                + cellValues[2] * (gridDelta[0] - dx) * dy
                + cellValues[3] * dx * dy
                ) / (gridDelta[0] * gridDelta[1]);

        unit = util.unit_to_displayunit(unit);

        var frac = util.get_frac(outValue, this.get_min_val(), this.get_max_val(), 0, 1);

        return {value_index: this.palette.get_index(outValue), value: outValue, frac: frac, unit: unit, precision: this.options.precision};
    },
    process_gridded_netcdf: function () {
        this.parent();
        if (this.palette) {
            this.palette = null;
        }
        this.get_palette();
    },
});